import React, { useEffect } from "react";
import "./careers.scss";
import Jumbotron from "../../components/jumbotron/Jumbotron";
import Divider from "../../components/Divider/Divider";
import { MOBILE_WIDTH } from "../../constants/screenSizes";
import { useWindowSize } from "../../hooks/useWindowSize";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

export default function Careers() {
  const windowSize = useWindowSize();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Jumbotron
        title="Join Our Team or Rent a Room"
        content="Looking to grow your career in a vibrant salon environment or need a beautiful space to run your business? We're always open to passionate professionals and entrepreneurs ready to thrive with us. Apply today or inquire about renting a room at our location."
        link={{
          label: "Ready to Join or Rent? Contact Us",
          url: "mailto:comfortcutzhr1@gmail.com",
          icon: faArrowUpRightFromSquare,
        }}
      />
      <div className="careers">
        <div className="careers-container">
          <div>
            <div className="careers-group">
              <p className="careers-primary">About Working at Comfort Cutz</p>
              <p className="careers-secondary">
                At Comfort Cutz, working here means more than just providing beauty services — it&apos;s about being
                part of a community. Rooted in Indigenous values and located just outside Kitchener-Waterloo, we offer a
                supportive, inclusive environment where creativity, culture, and care come together. You&apos;ll be
                welcomed into a team that values personal growth, mutual respect, and meaningful connections with
                clients. Join us, and help create a space where everyone — including you — feels at home.
              </p>
            </div>
            <br />
            <Divider auto position="horizontal" colour="secondary" thickness={2} />
            <br />
            <div className="careers-group">
              <p className="careers-primary">Rooms Available for Rent – Grow Your Business in Comfort</p>
              <p className="careers-secondary">
                Comfort Cutz offers bright, private rooms for rent in our spacious salon just outside
                Kitchener-Waterloo. Whether you&apos;re in the beauty, wellness, or personal care industry, our building
                provides a professional, welcoming environment where your business can thrive. You&apos;ll benefit from
                a serene atmosphere, flexible rental terms, and the support of an established salon community — all
                while maintaining your independence.
              </p>
            </div>
          </div>
          {windowSize.width > MOBILE_WIDTH && <Divider auto position="vertical" colour="secondary" thickness={2} />}
          <div>
            <div className="careers-group">
              <LazyLoadImage
                src={"images/insidesalon1.webp"}
                width="auto"
                className="career-img"
                alt="Comfort Cutz Salon"
                style={{ borderRadius: "8px" }}
              />
              <p className="careers-action-primary">
                📩 Interested? Email us at{" "}
                <a className="careers-email" href="mailto:comfortcutzhr1@gmail.com">
                  comfortcutzhr1@gmail.com
                </a>
              </p>
              <p className="careers-action-secondary">
                Please include a short introduction, your resume (if applying for a position), or details about your
                business (if inquiring about rentals).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
